'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Thumbnail_module = require('./Thumbnail.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Thumbnail = _ref => {
  let {
    s = {},
    src,
    alt
  } = _ref;
  const {
    width,
    height,
    ...rest
  } = s;
  const thumbnailTheme = {
    width: width ?? height,
    height: height ?? width,
    backgroundImage: `url("${src}")`,
    ...rest
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    role: "img",
    className: Thumbnail_module["default"].thumbnail,
    style: thumbnailTheme,
    "aria-label": alt,
    title: alt
  });
};

exports["default"] = Thumbnail;
